module.exports = __webpack_public_path__ + "img/addAttachment.0d68abef.gif";